import React from "react";
import Style from "./index.module.scss";
import { TopicsItem } from "../../../../Service";

interface Props {
    item: TopicsItem;
    onSave: (value: any) => void;
    children: React.ReactChild;
}
const Index = ({ item, children }: Props) => {
    return (
        <div className="cardMany">
            <h1 className={Style.title}>
                {item.index} - {item.typeName}
            </h1>
            <div className={Style.content}>
                <h2 className={Style.contentText}>{item.contentText}</h2>
                {children}
            </div>
        </div>
    );
};

export default Index;
